<template>
  <div>
    <havayollaricomp :etiket="$t('Airline-Code')" v-model="havayolubil"></havayollaricomp>
    <v-select hide-details=""  v-model="val.UcusTipi" :items="ucustipi" clearable
      item-text="text" item-value="value" :label="$t('Flight-Type')"></v-select>
    <v-checkbox :label="$t('This-ticket-purchased-from-agency')" v-model="acentabiletimi" hide-details=""></v-checkbox>
    <div v-if="acentabiletimi">
     <havayollaricomp :etiket="$t('Agency-Code')" v-model="acentabil"></havayollaricomp>
    </div>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"
  export default {
    props: ["value"],
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    mounted: function () {

    },
    watch: {
      'havayolubil.havayolukodu': function (value2) {
         this.val.HavaYoluKodu=value2
      },
       'havayolubil.formno': function (value3) {
         this.val.Formno=value3
      },
       'acentabil.havayolukodu': function (value4) {
         this.val.AcenteKodu=value4
         this.val.Acente='A'
      }
    },
    components: {
      havayollaricomp
    },
    beforeMount: beforeMount,
    methods: {
    },
    data() {
      return {
        havayolubil: {
          havayolukodu: null,
          formno: null
        },
         acentabil: {
          havayolukodu: null
        },
        itemsairlinelist: [],
        secilenformno: null,
        secilenhavayolukodu: null,
        ucustipi: [{
            text: this.$t('Domestic-Line'),
            value: 'I'
          },
          {
            text: this.$t('International-Line'),
            value: 'D'
          },
          {
            text: 'BSP',
            value: 'B'
          }
        ],
        coklubilet:false,
        ilkbiletlabel:'Bilet No',
        sonbiletno:null,
        acentabiletimi: false,
        yenidialog: false,
        denemedeger: null,
        dialogbaslik: '',
        resolve: null,
        kaydetbuton: false,
        tahsilatguncellebuton: false,
        k: null,
        doviztipi: [],
        reject: null,
        bankapositems: [],
        itemsbanka: [],
        statecaritahsilat: [],
        itemsevraktipi: [],
        tahsilatdialog: false,
        text1: null,
        searchcaritahsilat: '',
        taksitsayitahsilat: [],
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },

  }


  function beforeMount() {


  }
</script>